<template>
  <DsShowcase title="PaginationPlay" description="Componente de paginação com controle de páginas visíveis. Suporta v-model e eventos legados.">
    <!-- PROP: total / perPage -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">total / perPage</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>total: number</code> — total de itens. <code>perPage: number</code> — itens por página.</p>
      <div class="tw:space-y-4">
        <PaginationPlay v-model="page1" :total="100" :per-page="10" />
        <p class="tw:text-xs tw:opacity-50">Página: {{ page1 }} (100 itens, 10 por página = 10 páginas)</p>
      </div>
    </section>

    <!-- PROP: maxVisible -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">maxVisible</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — quantidade máxima de botões de página visíveis. Padrão: <code>4</code></p>
      <div class="tw:space-y-6">
        <div>
          <p class="tw:text-xs tw:mb-2 tw:opacity-60">maxVisible=3</p>
          <PaginationPlay v-model="page2" :total="200" :per-page="10" :max-visible="3" />
        </div>
        <div>
          <p class="tw:text-xs tw:mb-2 tw:opacity-60">maxVisible=7</p>
          <PaginationPlay v-model="page3" :total="200" :per-page="10" :max-visible="7" />
        </div>
      </div>
    </section>

    <!-- Navegação com setas -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Navegação com setas</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">As setas de anterior/próximo navegam corretamente e emitem <code>onSelectPage</code> com a nova página.</p>
      <div class="tw:space-y-2">
        <PaginationPlay v-model="page5" :total="80" :per-page="10" :max-visible="5" />
        <p class="tw:text-xs tw:opacity-50">Página atual: {{ page5 }} — Use as setas ← → para navegar</p>
      </div>
    </section>

    <!-- Poucos itens -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Poucos itens</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Quando total de páginas é menor que maxVisible</p>
      <PaginationPlay v-model="page4" :total="25" :per-page="10" />
    </section>

    <!-- Eventos legados -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Compatibilidade com eventos legados</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Suporta <code>:current-page</code> + <code>@on-select-page</code> / <code>@on-prev</code> / <code>@on-next</code> para uso sem v-model.</p>
      <div class="tw:space-y-2">
        <PaginationPlay :total="60" :per-page="10" :current-page="legacyPage" @on-select-page="legacyPage = $event" />
        <p class="tw:text-xs tw:opacity-50">Página (legado): {{ legacyPage }}</p>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { PaginationPlay } from '@/components/atomic'

const page1 = ref(1)
const page2 = ref(5)
const page3 = ref(10)
const page4 = ref(1)
const page5 = ref(4)
const legacyPage = ref(1)
</script>
